<template>
  <header class="app-header">
    <div class="header-content">
      <h1 class="header-title">Global AGV REST API</h1>
      <a href="https://www.global-agv.dk">
        <img :src="logoSrc" alt="Global AGV Logo" class="header-logo" />
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      logoSrc: require('@/assets/global_agv_logo_blaa_powered_by_bila.svg'),
    };
  },
};
</script>

<style scoped>
.app-header {
  background-color: #002d5b;
  color: whitesmoke;
  padding: 10px;
  text-align: center;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.header-logo {
  position: relative;
  height: 80px;
  width: auto;
}

.header-title {
  margin-left: 10px;
}
</style>
